import { Button } from "@mui/material";
import { memo, useCallback, useState } from "react";
import { ActivityModal } from "../modal/ActivityModal";
import { useSelector } from "react-redux";
import { authSelectors } from "../../state";
import { useGetUserActivityQuery } from "../../state/rtk-query/state/user";
import { skipToken } from "@reduxjs/toolkit/query";

export const UserActivityButton = memo(({ id }: { id?: number }) => {
  const isInternal = useSelector(authSelectors.isInternal);
  const [open, setOpen] = useState(false);
  const { data: { activities } = {} } = useGetUserActivityQuery(
    id ? { id } : skipToken,
    { skip: !isInternal, refetchOnMountOrArgChange: true },
  );
  const onClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setOpen(true);
    },
    [open],
  );
  if (!id) return null;
  if (!activities) return null;
  return (
    <>
      <Button
        onClick={onClick}
        disabled={!activities.length}
        sx={{ p: 0, fontWeight: 600 }}
        disableRipple
      >
        {activities.length ? "View activity" : "No activity"}
      </Button>
      <ActivityModal
        id={id}
        open={open}
        setOpen={setOpen}
        activities={activities}
        type="user"
      />
    </>
  );
});
